import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Estimate from 'components/Coupon/Estimate';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export default function EstimatePreview(props) {
  const { open, setOpenEstimate, orderNo, estimateInfo, modalClose } = props;

  const createEstimate = async (e) => {
    const page = document.getElementById('page');

    const canvas = await html2canvas(page, { scale: 4 });
    const imageFile = canvas.toDataURL('image/jpeg');
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();

    const widthRatio = pageWidth / canvas.width;
    const customHeight = canvas.height * widthRatio;
    doc.addImage(imageFile, 'png', 0, 0, pageWidth, customHeight);

    doc.save(`DAC_견적서_${new Date().getTime()}.pdf`);
    handleClose();
    modalClose();
  };

  const handleClose = (e) => {
    setOpenEstimate(false);
  };

  useEffect(() => {}, [open]);

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xl" aria-labelledby="draggable-dialog-title">
      <DialogContent>
        <Estimate orderNo={orderNo} estimateInfo={estimateInfo} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={createEstimate}>
          견적서 다운로드
        </Button>
        <Button variant="outlined" color="success" onClick={handleClose}>
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}
